import { render, staticRenderFns } from "./PageRowsConfig.vue?vue&type=template&id=2c3d4016"
import script from "./PageRowsConfig.vue?vue&type=script&lang=js"
export * from "./PageRowsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports